<div class="loader-wrapper content-tabs">
  <ng-container *ngIf="campaign && campaignDetails">
    <h1>{{ "brand.campaign.content.contentTitle" | translate }}</h1>
    <p class="section-description">
      {{ "brand.campaign.content.createTitle" | translate }}
    </p>
    <div class="row">
      <div
        class="col posts-wrapper {{ campaign.isEditable ? 'editable' : '' }}"
      >
        <mat-tab-group
          mat-stretch-tabs="false"
          [(selectedIndex)]="postsTabsSelectedIndex"
          class="brand-style"
          #navigationElement
        >
          <ng-container
            *ngFor="let category of campaignDetails.orderedCategories"
          >
            <mat-tab [id]="category.id">
              <ng-template mat-tab-label>
                <div class="category-tab-label">
                  <div class="tab-title">{{ category.title }}</div>
                  <div class="tab-subtitle">{{ category.subtitle }}</div>
                </div>
                <mat-icon
                  class="tab-edit"
                  (click)="onEditCategory(category)"
                  *ngIf="campaign.isEditable"
                  >edit</mat-icon
                >
              </ng-template>

              <ng-template matTabContent>
                <section class="content-grid">
                  <div
                    class="add-content-btn"
                    (click)="onAddContent(category)"
                    *ngIf="campaign.isEditable"
                  >
                    <mat-icon class="add-content-btn--icon">add</mat-icon>
                    <span class="add-content-btn--text"
                      >{{ "brand.campaign.content.addMaterialTo" | translate }}
                      <strong>"{{ category.title }}"</strong></span
                    >
                  </div>

                  <section
                    class="post-grid {{ firstSectionMargin(category) }}"
                    *ngIf="category.posts.length > 0"
                  >
                    <h3 *ngIf="category.posts.length > 0">
                      {{ "brand.campaign.content.sectionTitle" | translate }}
                    </h3>
                    <p *ngIf="category.posts.length > 0" class="section-intro">
                      {{ "brand.campaign.content.sectionSubtitle" | translate }}
                    </p>

                    <!-- Category posts section -->
                    <ng-container *ngFor="let post of category.posts">
                      <app-campaign-content-post
                        [campaign]="campaign"
                        [campaignDetails]="campaignDetails"
                        [category]="category"
                        [post]="post"
                        [isEditable]="campaign.isEditable"
                        (postDeleted)="onDeletePost($event)"
                      >
                      </app-campaign-content-post>
                    </ng-container>
                  </section>

                  <section
                    class="images {{ secondSectionMargin(category) }}"
                    ng-container
                    *ngIf="category?.images && category.images.length > 0"
                  >
                    <h3>
                      {{
                        "brand.campaign.content.categoryImagesTitle" | translate
                      }}
                    </h3>
                    <p class="section-intro">
                      <strong>{{
                        "brand.campaign.content.usage" | translate
                      }}</strong
                      >&nbsp;
                      {{ "brand.campaign.content.imagesUsage" | translate }}
                    </p>
                    <div *ngFor="let imageType of category.images">
                      <ng-container *ngIf="imageType.files.length > 0">
                        <div class="content-title">
                          <h4>{{ imageType.title }}</h4>
                          <div
                            *ngIf="campaign.isEditable"
                            class="content-actions"
                          >
                            <mat-icon
                              class="action delete"
                              (click)="
                                onDeleteBannerConfirm(category, imageType)
                              "
                              >delete</mat-icon
                            >
                            <mat-icon
                              class="action"
                              (click)="onEditBanner(category, imageType)"
                              >edit</mat-icon
                            >
                          </div>
                        </div>
                        <ul class="banner-list">
                          <li
                            class="banner-item"
                            #li
                            *ngFor="let file of imageType.files"
                          >
                            <div
                              class="banner-item-download"
                              [ngStyle]="{
                                'background-image':
                                  'url(' +
                                  optimizeImage(file.file, file.filePublicId) +
                                  ')'
                              }"
                            >
                              <a
                                target="_blank"
                                href="{{
                                  getDownloadUrl(file.file, file.filePublicId)
                                }}"
                                ><img
                                  class="banner-item-icon"
                                  src="/assets/images/icons/ic_download_icon.svg"
                                  alt="Download"
                              /></a>
                              <img
                                class="banner-item-img"
                                src="{{
                                  optimizeImage(file.file, file.filePublicId)
                                }}"
                                #img
                                (load)="imageWideRelatedClass(img, li)"
                              />
                            </div>
                          </li>
                        </ul>
                        <div
                          class="banner-list-empty"
                          *ngIf="imageType.files.length === 0"
                        >
                          {{ "brand.campaign.content.noImages" | translate }}
                        </div>
                      </ng-container>
                    </div>
                  </section>

                  <section
                    class="videos"
                    *ngIf="category?.videos && category.videos.length > 0"
                  >
                    <h3>
                      {{
                        "brand.campaign.content.categoryVideosTitle" | translate
                      }}
                    </h3>
                    <p class="section-intro">
                      <strong>{{
                        "partner.contentArea.usageLabel" | translate
                      }}</strong
                      >&nbsp;{{
                        "brand.campaign.content.categoryVideosSubtitle"
                          | translate
                      }}
                    </p>
                    <ul class="video-list" *ngIf="category.videos">
                      <li
                        class="video-item"
                        *ngFor="let video of category.videos"
                      >
                        <div class="video-item-panel-title">
                          <span class="video-item-title-label">{{
                            "partner.contentArea.videoTitle" | translate
                          }}</span>
                          {{ video.title }}<br />
                          <ng-container *ngIf="video.link">
                            <span class="video-item-panel-url">
                              <strong>{{
                                "partner.contentArea.videoLink" | translate
                              }}</strong>
                            </span>
                            {{ video.link }}
                            <button
                              class="btn--image-only"
                              (click)="copyLink(video.link)"
                            >
                              <img
                                class="video-item-copy-link"
                                src="/assets/images/icons/ic_copy_clipboard.svg"
                                title="{{ 'shared.copyLink' | translate }}"
                              />
                            </button>
                          </ng-container>
                        </div>

                        <video
                          *ngIf="video.downloadLink"
                          style="width: 100%"
                          src="{{ video.downloadLink }}"
                          preload="metadata"
                          controls
                        ></video>

                        <div
                          *ngIf="!video.downloadLink"
                          class="video-item-image-wrapper"
                        >
                          <div
                            *ngIf="!video.link"
                            class="video-item-image-link"
                            [ngStyle]="{
                              'background-image':
                                'url(' + getVideoImage(video) + ')'
                            }"
                          ></div>
                          <a
                            *ngIf="video.link"
                            class="video-item-image-link"
                            [ngStyle]="{
                              'background-image':
                                'url(' + getVideoImage(video) + ')'
                            }"
                            href="{{ video.link }}"
                            target="_blank"
                          ></a>
                        </div>

                        <ng-container *ngIf="video.downloadLink">
                          <div class="video-item-panel-download">
                            <div class="video-item-download-label">
                              {{
                                "brand.campaign.content.downloadVideo"
                                  | translate
                              }}
                            </div>
                          </div>
                        </ng-container>

                        <div class="actions">
                          <a
                            *ngIf="campaign.isEditable"
                            class="button-link delete"
                            (click)="onDeleteVideoConfirm(category, video)"
                            >{{ "shared.delete" | translate }}</a
                          >
                          <div class="right">
                            <a
                              *ngIf="campaign.isEditable"
                              class="button-grey"
                              (click)="onEditVideo(category, video)"
                            >
                              {{ "shared.edit" | translate }}
                            </a>
                            <a
                              class="button-grey"
                              href="{{ video.downloadLink }}"
                              target="_blank"
                            >
                              {{ "shared.download" | translate }}
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </section>
                </section>
              </ng-template>
            </mat-tab>
          </ng-container>
        </mat-tab-group>
      </div>
    </div>
  </ng-container>

  <div class="add-category-btn-wrapper" style="opacity: 0" #addCategoryBtn>
    <div
      class="add-category-btn"
      *ngIf="campaign && campaign.isEditable"
      (click)="onAddCategory()"
    >
      <img
        class="add-category-btn--icon"
        alt="add category"
        src="assets/images/icons/ic_addContent.svg"
      />
      <span class="add-category-btn--text">
        {{ "brand.campaign.content.addCategory" | translate }}
      </span>
    </div>
  </div>
</div>
